// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-profile-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.quick-profile-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 800px;
  width: 100%;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.quick-profile-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0877BC, #065a8f);
}

.quick-profile-header {
  text-align: center;
  margin-bottom: 40px;
}

.user-type-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.user-type-icon {
  font-size: 32px !important;
  color: #0877BC;
}

.quick-profile-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  background: linear-gradient(135deg, #0877BC, #065a8f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.quick-profile-subtitle {
  font-size: 1.1rem;
  color: #718096;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.quick-profile-form {
  width: 100%;
}

.questions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

.question-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 4px;
}

.question-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.question-icon {
  font-size: 18px !important;
  color: #0877BC;
}

.required {
  color: #e53e3e;
  margin-left: 4px;
}

.question-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  color: #2d3748;
  background: #ffffff;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.question-input:focus {
  outline: none;
  border-color: #0877BC;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
}

.question-input.error {
  border-color: #e53e3e;
  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);
}

.question-input::placeholder {
  color: #a0aec0;
}

.question-input select {
  cursor: pointer;
}

.question-input select option {
  padding: 8px;
}

.error-message {
  color: #e53e3e;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 4px;
}

.quick-profile-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.back-button {
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.back-button:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
  transform: translateY(-1px);
}

.continue-button {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 32px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  flex: 1 1;
  max-width: 200px;
  box-shadow: 0 4px 15px rgba(8, 119, 188, 0.3);
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.4);
}

.continue-button:active {
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 768px) {
  .quick-profile-card {
    padding: 24px;
    margin: 10px;
  }

  .quick-profile-title {
    font-size: 2rem;
  }

  .quick-profile-subtitle {
    font-size: 1rem;
  }

  .questions-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .question-group {
    gap: 6px;
  }

  .question-label {
    font-size: 0.9rem;
  }

  .question-input {
    padding: 10px 14px;
    font-size: 0.9rem;
  }

  .quick-profile-actions {
    flex-direction: column;
    gap: 12px;
  }

  .back-button,
  .continue-button {
    width: 100%;
    max-width: none;
  }
}

@media (max-width: 480px) {
  .quick-profile-container {
    padding: 10px;
  }

  .quick-profile-card {
    padding: 20px;
  }

  .quick-profile-title {
    font-size: 1.75rem;
  }

  .user-type-indicator {
    flex-direction: column;
    gap: 8px;
  }

  .user-type-icon {
    font-size: 28px !important;
  }

  .questions-grid {
    gap: 16px;
  }
}

/* Animation for form appearance */
.quick-profile-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.question-group {
  animation: fadeInUp 0.4s ease-out;
  animation-fill-mode: both;
}

.question-group:nth-child(1) { animation-delay: 0.1s; }
.question-group:nth-child(2) { animation-delay: 0.2s; }
.question-group:nth-child(3) { animation-delay: 0.3s; }
.question-group:nth-child(4) { animation-delay: 0.4s; }
.question-group:nth-child(5) { animation-delay: 0.5s; }
.question-group:nth-child(6) { animation-delay: 0.6s; }
.question-group:nth-child(7) { animation-delay: 0.7s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/QuickProfileQuestions.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,kCAAkC;AAClC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;;AAEtD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".quick-profile-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.quick-profile-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 800px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.quick-profile-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0877BC, #065a8f);\n}\n\n.quick-profile-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.user-type-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.user-type-icon {\n  font-size: 32px !important;\n  color: #0877BC;\n}\n\n.quick-profile-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.quick-profile-subtitle {\n  font-size: 1.1rem;\n  color: #718096;\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.quick-profile-form {\n  width: 100%;\n}\n\n.questions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n.question-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.question-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 4px;\n}\n\n.question-icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n}\n\n.question-icon {\n  font-size: 18px !important;\n  color: #0877BC;\n}\n\n.required {\n  color: #e53e3e;\n  margin-left: 4px;\n}\n\n.question-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  color: #2d3748;\n  background: #ffffff;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.question-input:focus {\n  outline: none;\n  border-color: #0877BC;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n}\n\n.question-input.error {\n  border-color: #e53e3e;\n  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);\n}\n\n.question-input::placeholder {\n  color: #a0aec0;\n}\n\n.question-input select {\n  cursor: pointer;\n}\n\n.question-input select option {\n  padding: 8px;\n}\n\n.error-message {\n  color: #e53e3e;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.quick-profile-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.back-button {\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n}\n\n.back-button:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n  transform: translateY(-1px);\n}\n\n.continue-button {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 32px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 140px;\n  flex: 1;\n  max-width: 200px;\n  box-shadow: 0 4px 15px rgba(8, 119, 188, 0.3);\n}\n\n.continue-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.4);\n}\n\n.continue-button:active {\n  transform: translateY(0);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .quick-profile-card {\n    padding: 24px;\n    margin: 10px;\n  }\n\n  .quick-profile-title {\n    font-size: 2rem;\n  }\n\n  .quick-profile-subtitle {\n    font-size: 1rem;\n  }\n\n  .questions-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .question-group {\n    gap: 6px;\n  }\n\n  .question-label {\n    font-size: 0.9rem;\n  }\n\n  .question-input {\n    padding: 10px 14px;\n    font-size: 0.9rem;\n  }\n\n  .quick-profile-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .quick-profile-container {\n    padding: 10px;\n  }\n\n  .quick-profile-card {\n    padding: 20px;\n  }\n\n  .quick-profile-title {\n    font-size: 1.75rem;\n  }\n\n  .user-type-indicator {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .user-type-icon {\n    font-size: 28px !important;\n  }\n\n  .questions-grid {\n    gap: 16px;\n  }\n}\n\n/* Animation for form appearance */\n.quick-profile-card {\n  animation: slideInUp 0.6s ease-out;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.question-group {\n  animation: fadeInUp 0.4s ease-out;\n  animation-fill-mode: both;\n}\n\n.question-group:nth-child(1) { animation-delay: 0.1s; }\n.question-group:nth-child(2) { animation-delay: 0.2s; }\n.question-group:nth-child(3) { animation-delay: 0.3s; }\n.question-group:nth-child(4) { animation-delay: 0.4s; }\n.question-group:nth-child(5) { animation-delay: 0.5s; }\n.question-group:nth-child(6) { animation-delay: 0.6s; }\n.question-group:nth-child(7) { animation-delay: 0.7s; }\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
